// extracted by mini-css-extract-plugin
export default {"whatsapp-button-container":"WhatsApp_whatsapp-button-container__bzCKc","whatsapp-button":"WhatsApp_whatsapp-button__ApR4k","whatsapp-icon":"WhatsApp_whatsapp-icon__eQLnF"};